{
    "default": {
        "success": "Acción exitosa",
        "fail": "Ha ocurrido un error"
    },
    "default.action": {
        "consulta": {
            "fail": "Ocurrió un error consultar la información"
        },
        "record": {
            "success": "Se ha registrado exitosamente",
            "fail": "Ocurrió un error intentar registrar"
        },
        "update": {
            "success": "Se ha actualizado exitosamente",
            "fail": "Error al actualizar"
        },
        "delete": {
            "success": "Se ha eliminado exitosamente",
            "fail": "Registro no eliminado"
        }
    },
    "grupo": {
        "LoginV4": {
            "0": "Usuario incorrecto",
            "-1": "Contraseña incorrecta",
            "-2": "El grupo no tiene horario disponible"
        },
        "Salida": {
            "fail": "Ocurrió un error, intenta de nuevo",
            "-1": "Alumn@ no activo o no tiene entrada a grupo",
            "-2": "Alumn@ ya se encuentra en grupo"
        },
        "Entrada": {
            "-1": "Alumn@ no activo o ya está en grupo"
        },
        "SalidaEscuela": {
            "success": "_ salió de la escuela",
            "fail": "Ocurrió un error al dar salida en escuela"
        },
        "RechazarEntrada": {
            "success": "Se rechazó la entrada de _",
            "fail": "Ocurrió un error al rechazar entrada"
        },
        "EscanearQr": {
            "fail": "Error al procesar QR",
            "-1": "QR caducado o no existe",
            "-2": "QR incorrecto",
            "-3": "Alumno no encontrado",
            "-4": "Tipo de QR no permitido",
            "-5": "Sin permisos para escanear QR"
        }
    },
    "sesion": {
        "RecuperarContrasenia": {
            "1": "SMS enviado",
            "-1": "El usuario no existe",
            "-2": "El usuario no tiene un número de teléfono válido",
            "-3": "Ocurrió un error al enviar el SMS"
        }
    },
    "alumno": {
        "ActualizarFotoPerfil": {
            "success": "La foto se actualizó correctamente"
        },
        "ObtenerExtemporaneosDisponiblesHoy": {
            "-1": "Ocurrió un error, el grupo no está disponible",
            "-2": "Ocurrió un error, la escuela no opera este día",
            "-3": "Ocurrió un error, la escuela se encuentra fuera del horario de operación"
        },
        "ObtenerHorarioHoy": {
            "fail": "Ocurrió un error al procesar horarios"
        }
    },
    "evento": {
        "comun": {
            "-10": "La escuela ya no está disponible",
            "-11": "La escuela no estuvo en operación",
            "-12": "La escuela no está en horario de operación",
            "-13": "Los alumnos no se encontraron dentro del horario escolar"
        },
        "RegistrarSiesta": {
            "-4": "El/los alumnos ya durmieron durante éste rango de horas"
        },
        "RegistrarAlimento": {
            "-2": "Eventos de comida no disponibles",
            "-3": "Horario de escuela no configurado",
            "-4": "No hay comida registrada para el día",
            "-5": "Catálogo comida no válido"
        },
        "RegistrarHigieneV2": {},
        "RegistrarFotoV3": {
            "success": "Fotos registradas correctamente",
            "fail": "Ocurrió un error al subir las fotos"
        }
    },
    "logro": {
        "EditarEstadoAsignacionV3": {
            "success": "Se ha registrado correctamente el logro",
            "fail": "Error al editar asignación",
            "-2": "El estado no es válido"
        }
    },
    "escolaridad": {
        "ObtenerConfiguracion": {
            "fail": "No es posible obtener configuración",
            "-60": "Usuario no tiene configuración"
        }
    },
    "Agenda": {
        "NuevaTarea": {},
        "ActualizarTarea": {},
        "EliminarTarea": {}
    },
    "calificacion": {
        "ObtenerPendientes": {},
        "Asignar": {
            "-14": "El alumno con inasistencias"
        },
        "ObtenerAsistencias": {
            "-11": "Ocurrió un error al obtener las asistencias del alumno"
        }
    }
}